function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, Fragment } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import ExitPopupComponent from "/components/addons/exit-popup/exit-popup-component";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { withAbTests } from "contexts/ab-tests-context";
class CoreAddonsComponent extends PureComponent {
    componentDidMount() {
        //TODO: Remove and change GTM trigger to page load
        fireGtmEvent(DataLayerEventTypes.SHOW_COOKIEHUB_DIALOG_EVENT_NAME);
    //If we see that CookieHub Geolocation isn't working well we can fire a GTM event only for relevant countries + another for the rest to launch all cookies
    }
    render() {
        const { exitPopup, exitPopupConfig } = this.props;
        return /*#__PURE__*/ _jsx(Fragment, {
            children: exitPopup && /*#__PURE__*/ _jsx(ExitPopupComponent, _object_spread({}, exitPopupConfig))
        });
    }
}
export default withAbTests(withGenericConfig(CoreAddonsComponent));
